import { useMemo } from "react";
import { DEMAND } from "@demandproai/shared";

const LIFECARE_TOOLTIP = "Download Lifecare Plan";
const DEFAULT_TOOLTIP = "Download Document";
const LOADING_ICON = "fa fa-spinner animate-spin";
const IDLE_ICON = "fa fa-download";

const useDemandStudioPreviewDownloadButton = ({caseId, isOpen, docxFiles, clients, usePreviewHook, forcedDemandType, forcedClientId}) => {
  const previewState = usePreviewHook({
    caseId,
    isOpen,
    docxFiles,
    clients,
    forcedDemandType,
    forcedClientId,
  });
  const { onDownloadPreview, isDownloading, canDownloadPreview, selectedDemandType } = previewState;

  const isLifecareSelected = selectedDemandType === DEMAND.Lifecare_Plan;

  const buttonProps = useMemo(
    () => ({
      tooltipTitle: isLifecareSelected ? LIFECARE_TOOLTIP : DEFAULT_TOOLTIP,
      icon: isDownloading ? LOADING_ICON : IDLE_ICON,
      onClick: onDownloadPreview,
      disabled: !canDownloadPreview || isDownloading,
    }),
    [isLifecareSelected, isDownloading, onDownloadPreview, canDownloadPreview]
  );

  return buttonProps;
};

export default useDemandStudioPreviewDownloadButton;
